var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSubscribe24 = function SvgSubscribe24(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.8357 19c0 1.6569-1.2696 3-2.8357 3s-2.83568-1.3431-2.83568-3m4.53378-12.76144c.4116-.44992.665-1.06294.665-1.73856 0-1.38071-1.058-2.5-2.3631-2.5s-2.36306 1.11929-2.36306 2.5c0 .67562.25332 1.28864.66496 1.73856m7.3695 4.96144c0-1.37913-.5976-2.70177-1.6611-3.67696-1.0636-.97518-2.5062-1.52304-4.0103-1.52304s-2.94667.54786-4.01025 1.52304c-1.06359.97519-1.6611 2.29783-1.6611 3.67696 0 2.2818-.53488 3.9506-1.20227 5.1447-.76065 1.3609-1.14097 2.0414-1.12595 2.2039.01718.186.04882.2447.19138.355.12461.0964.75067.0964 2.00279.0964h11.6108c1.2521 0 1.8782 0 2.0028-.0964.1426-.1103.1742-.169.1914-.355.015-.1625-.3653-.843-1.126-2.2039-.6674-1.1941-1.2022-2.8629-1.2022-5.1447z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSubscribe24);
export default ForwardRef;